<template>
    <div>
        <div v-if="errorType === 'error message'" class="api-errors">
            <div v-for="(errorObject, key) in errors" :key="key" class="alert alert-danger" role="alert">
                <strong>{{ key }}:</strong>
                <div v-if="Array.isArray(errorObject)">
                    <ul v-if="errorObject.length > 1">
                        <li v-for="err in errorObject" :key="err">
                            {{ err }}
                        </li>
                    </ul>
                    <template v-else>
                        {{ errorObject[0] }}
                    </template>
                </div>
                <div v-else>
                    {{ errorObject }}
                </div>
            </div>
        </div>
        <div v-if="errorType === 'error page'" class="col-sm-12 text-center api-errors content-width container-spacing">
            <div v-for="(errorObject, key) in errors" :key="key">
                <h1 class="text-info">
                    <strong>{{ key }}</strong>
                </h1>
                <p>
                    {{ errorObject }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
// Displays all errors in one place
import { capitalize } from 'src/lib/utils.js'
export default {
    props: {
        errors: {
            type: [Object, Array],
            default: () => ({}),
        },
        // Types of error display: 'error meassage' and 'error page'
        errorType: {
            type: String,
            default: 'error message'
        }
    },
    methods: {
        capitalize: capitalize
    }
}
</script>
